import React from 'react';

import { isEqual } from 'lodash';

import { siteIds } from '../../../constants';
import { siteId, brandSite } from '../../../sites';

import ViinimaaPageWrapper from './viinimaa';

function PageWrapper(props) {
  if (isEqual(siteId, siteIds.Viinimaa)) {
    return <ViinimaaPageWrapper {...props} />;
  }
  if (isEqual(siteId, siteIds.Folkofolk)) {
    return <ViinimaaPageWrapper {...props} />;
  }
  if (brandSite) {
    return <ViinimaaPageWrapper {...props} />;
  }

  return null;
}

export default PageWrapper;
